import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '5575981872440';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent('Olá, vim do site de nódulo e gostaria de agendar uma consulta com dr. Mateus')}`;

export default function NoduloWhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white font-poppins font-semibold text-sm px-5 py-3.5 rounded-full shadow-2xl hover:bg-[#1da851] hover:-translate-y-1 transition-all duration-200 group"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline">Falar pelo WhatsApp</span>
    </a>
  );
}
